export default function getRetailNameFromHost(host: string): string {
  return host.split('.')[0].split('-review-')[0];
}
